export default __webpack_public_path__ + "media/zurb/img/playground/ux-card-etymology-ec798fb56167f6102f7078273809ffd9.png";